import { FC, ReactNode } from 'react'
import {
  SevenroomsVenueGroupOption,
  SevenroomsVenueGroupOptionType,
} from './Option'

const SevenroomsVenueGroup: FC &
  SevenroomsVenueGroupOptionType = (): ReactNode => <></>

SevenroomsVenueGroup.Option = SevenroomsVenueGroupOption

export default SevenroomsVenueGroup
